import Order, { OrderType } from "../../../../../../../services/Order";

const cellProcessing = (item: Order.Model): string => {
	const passengers = item.passengers ?? [];
	if (!passengers.length) return "";

	const person =
		item.type === OrderType.CUSTOMER_SPONSORED
			? item.billingCustomer?.person
			: passengers[0]?.customer?.person;

	const name = person?.name ?? "";
	const surname = person?.surname ?? "";
	const fatherName = person?.fatherName ?? "";

	return `${surname} ${name} ${fatherName}`.trim() || "";
};

export default cellProcessing;
